import { ObjectListResponseType } from '../ObjectListResponseTypes'

interface TicketListResponse extends ObjectListResponseType {
  tickets: TicketResponse[]
}
interface TicketResponse {
  ticketId: number
  description: string
  date: string
  departmentId: number
  department: string
  departmentSubId: number
  departmentSub: string
  statusId: number
  status: string
  ticketLinks: Array<TicketLinkResponse>
  priority: string
  timeOpened: string
  resolution: string
  dateClosed: string
  isArchived: boolean
  createdBy: string
  zabbix_link: string
}
export interface TicketLinkResponse {
  objectName: string
  objectId: number
}
interface TicketHistoryListResponse extends ObjectListResponseType {
  histories: TicketHistoryResponse[]
}
interface TicketHistoryResponse {
  historyId: number
  date: string
  inputTypeId: number
  inputType: string
  actionTypeId: number
  actionType: string
  content: string
  employeeId: number
  employee: string
  createdBy: string
  attachments: Array<TicketAttachmentResponse>
}
interface TicketAttachmentResponse {
  fileName: string
  fileType: string
  fileDate: string
  fileUrl: string
  fileId: number
}
const isTicketHistoryListResponse = (history: any): history is TicketHistoryListResponse => {
  if (history === undefined) {
    return false
  }
  return 'histories' in history
}
const isTicketHistoryResponse = (history: any): history is TicketHistoryResponse => {
  if (history === undefined) {
    return false
  }
  return 'historyId' in history
}
const isTicketResponse = (response: any): response is TicketResponse => {
  if (response === undefined) {
    return false
  }
  return 'ticketId' in response
}
const isTicketListReponseType = (ticketlist: any): ticketlist is TicketListResponse => {
  if (ticketlist === undefined) {
    return false
  }
  return 'tickets' in ticketlist
}
export type { TicketResponse, TicketHistoryResponse, TicketListResponse, TicketHistoryListResponse }
export { isTicketListReponseType, isTicketHistoryListResponse, isTicketHistoryResponse, isTicketResponse }
